/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { etoileProgrammes2 } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_multi_013: Question = {
  id: 'multi-013-jardins-partages',
  oldId: '74',
  title: 'Programmes de jardins partagé',
  number: '7.5',
  description: ['L\'organisation participe à des programme de jardins communautaires et collectifs et/ou d\'aménagements comestibles (nombres de programmes)'],
  type: QuestionType.INDICATOR,
  frequency: 1,
  slots: [
    {
      type: SlotTypes.ETOILES,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: true,
      scoringFct: (data:number) => {
        if (data >= 3) return 3;
        if (data >= 2) return 2;
        if (data >= 1) return 1;
        return 0;
      },
      score: '0',
      maxScore: 3,
      help: etoileProgrammes2,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

const question_multi_013__v3: Question = {
  ...question_multi_013,
  title: 'Nombres de jardins partagé',
};

export const question_multi_013_v2: Question = question_multi_013;
export const question_multi_013_v3: Question = question_multi_013__v3;
